<template>
  <hypto-popup :title="'Role Confirmation'">
    <template v-slot:body>
      <p>All users who are assigned this role will have access based on the privileges you have chosen now.</p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="updateRole">Confirm</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

export default {
  name: 'RoleConfirmation',
  components: { HyptoPopup },
  methods: {
    updateRole () {
      this.$emit('updateRole')
    }
  }
}
</script>
